import React from "react";

import ServiceRouteTimeCell from "./ServiceRouteTimeCell";
import { getServiceRouteDepartureTime, getServiceRouteArrivalTime } from "./serviceRouteListTimes";

export function getServiceRouteTimeColumns(t) {
  return [
    {
      field: "routeDepartureTime",
      headerName: t("routeDepartureTime"),
      width: 110,
      sortable: true,
      valueGetter: (params) => getServiceRouteDepartureTime(params.row) || "",
      renderCell: (params) => <ServiceRouteTimeCell row={params.row} kind="departure" />,
    },
    {
      field: "routeArrivalTime",
      headerName: t("routeArrivalTime"),
      width: 110,
      sortable: true,
      valueGetter: (params) => getServiceRouteArrivalTime(params.row) || "",
      renderCell: (params) => <ServiceRouteTimeCell row={params.row} kind="arrival" />,
    },
  ];
}
